import type React from 'react';

import DebugPanel from '@/components/organism/DebugPanel/DebugPanel';
import { useDebugPanel } from '@/hooks/debug/useDebugPanel';

function DebugPanelContainer(): React.JSX.Element | null {
  const { state, handlers } = useDebugPanel();

  if (!state.isOpen) return null;

  return (
    <DebugPanel
      activeTab={state.activeTab}
      storageEstimate={state.storageEstimate}
      browserInfo={state.browserInfo}
      percentFree={state.percentFree}
      heightPx={state.heightPx}
      logEntries={state.logEntries}
      logNamespaces={state.logNamespaces}
      logLevel={state.logLevel}
      p2pDiagnostics={state.p2pDiagnostics}
      sessionSnapshot={state.sessionSnapshot}
      dragHandleProps={handlers.dragHandleProps}
      onClose={handlers.handleClose}
      onTabChange={handlers.handleTabChange}
      onCopy={handlers.handleCopy}
      onCopyAll={handlers.handleCopyAll}
      onSetLogPattern={handlers.handleSetLogPattern}
      onSetLogLevel={handlers.handleSetLogLevel}
      onClearLogs={handlers.handleClearLogs}
      onCopyReduxState={handlers.handleCopyReduxState}
    />
  );
}

export default DebugPanelContainer;
